import { withTableView } from '@components/enitity/table/Table.view'
import { useTranslation } from 'react-i18next'

import { CronJobsTable } from '../../components/CronJobsTable'

export const CronJobs = () => {
  const { t } = useTranslation('cron')
  const TableWithView = withTableView(CronJobsTable, t('title'))
  return <TableWithView />
}
